export const fr = {
  footer: {
    cta: "Commencez à avoir un impact dans votre communauté aujourd'hui",
    copyright: "© Purposely",
    tagline: "Le copilote IA du bénévolat d'entreprise. Impact automatisé.",
    location: "Fait à Vancouver, C.-B.",
    sections: {
      company: {
        title: "Entreprise",
        links: {
          about: "À propos de nous",
          contact: "Contact",
          privacy: "Politique de confidentialité",
          terms: "Conditions d'utilisation"
        }
      },
      product: {
        title: "Produit",
        links: {
          features: "Fonctionnalités",
          howItWorks: "Comment ça marche",
          integrations: "Intégrations",
          reporting: "Rapports",
          eventManagement: "Gestion d'événements",
          referral: "Programme de parrainage",
        }
      },
      resources: {
        title: "Ressources",
        links: {
          caseStudies: "Études de cas",
          nonprofits: "Pour les organismes",
          whatsNew: "Nouveautés",
          blog: "Blog",
          helpCenter: "Centre d'aide",
        }
      },
      legal: {
        title: "Mentions légales",
        links: {
          security: "Sécurité",
          cookiePreferences: "Préférences de témoins",
        }
      },
      affiliations: {
        title: "Affiliations"
      },
      connect: {
        title: "Connexion",
        socialAlt: {
          facebook: "Lien Facebook",
          twitter: "Lien Twitter",
          instagram: "Lien Instagram",
          linkedin: "Lien LinkedIn"
        }
      }
    },
    purpleHeartAlt: "Cœur violet de Purposely"
  }
}